module.exports = __webpack_public_path__ + "media/fonts/SFProText-Heavy-391b783f76a02a90f852c89ce9237973.woff2";